<p-dropdown [options]="list" [(ngModel)]="selectedItem" optionLabel="label" [filter]="true" filterBy="name" [showClear]="true" [placeholder]="placeHolderLanguage" (onChange)="feedback()">


